module.exports = __webpack_public_path__ + "img/submit-query-compound.532d153e.gif";